import queryString from 'query-string';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useService } from '@atlassian/jira-common-services/src/use-service/index.tsx';
import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge/src/utils/fire-analytics';
import { performCmdbGetRequest } from '@atlassian/jira-servicedesk-cmdb-client/src/fetch.tsx';
import { MAXIMUM_PROJECTS_THRESHOLD } from '../common/constants.tsx';
import type { ProjectResponse, Page } from '../common/types.tsx';

export type ProjectsQueryString = {
	query: string;
	orderBy: string;
	startAt: string;
	maxResults: string;
};

export const generateUrl = (query: string, orderBy = 'NAME', startAt = '0'): string => {
	const qs: ProjectsQueryString = {
		query,
		orderBy,
		startAt,
		maxResults: MAXIMUM_PROJECTS_THRESHOLD,
	};

	return `/rest/api/3/project/search?${queryString.stringify(qs)}`;
};

export const useProjectsSearch = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const searchProjects = async (query: string): Promise<ProjectResponse[]> => {
		try {
			const projects: Page<ProjectResponse> = await performCmdbGetRequest(generateUrl(query));
			fireTrackAnalytics(createAnalyticsEvent({}), 'insightSearchProjects succeeded');
			return projects.values;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireCmdbErrorAnalytics({
				error,
				meta: {
					id: 'insightSearchProjects',
					teamName: 'falcons',
					packageName: 'jiraServicedeskInsightProjectsPicker',
				},
			});
			throw error;
		}
	};

	const { data, loading, error, fetch } = useService<ProjectResponse[], string>(searchProjects);

	return [{ data, loading, error }, { searchProjects: fetch }] as const;
};
